export default "/static/293587c05f6413a1.svg"